<template lang="pug">
    el-dialog(:title="!dataForm.id ? '新增' : '修改'",width="95%", :close-on-click-modal='false', :append-to-body="true" :visible.sync='visible' :modal-append-to-body='false'  @closed="reset")
      el-form(:model='dataForm',  :rules='dataRule', ref='dataForm', label-suffix=":" label-width="auto" )
        el-card(shadow="never")
          div(slot="header")
            font(style="font-weight: bold;font-size:18px;") {{!dataForm.id ? '新增合作方' : '修改合作方'}}
          div
            el-form-item(label='标题', prop='title')
              el-input.width_ct(v-model='dataForm.title', placeholder='请填写合作方名称' clearable)
            el-form-item(label='类型', prop='type')
              el-select.sel_width_ct(v-model="dataForm.type", placeholder="请选择合作方类型" clearable)
                el-option(v-for="(item,index) in type_list",:key="index",:label="item.label",:value="item.value")
              el-tooltip(class="item" effect="dark" content="类型是“赞助商”时，必须关联一个主办方。" placement="right")
                i(class="el-icon-warning-outline icon")
            el-form-item(label="LOGO" prop="logo")
              el-input(v-model="dataForm.logo" v-show="false")
              div(style="width:240px;height:180px;margin-top:12px;")
                //- img(v-if="imageUrl" :src="imageUrl" @click="openImgdailog" style="width:100%")
                img(v-if="imageUrl" :src="imageUrl" @click="openImgdailog" style="width:240px;height:180px;")
                i(v-else class="el-icon-plus avatar-uploader-icon" @click="openImgdailog" style="width:240px;height:180px;")
              imgupload(v-if="openImg" ref="upimg" :width="240" :height="180" @uploadSuccess='doneup')
            el-form-item(label='LOGO排序号', prop='logo_sort')
              el-input.width_ct(v-model='dataForm.logo_sort', placeholder='请输入前端显示顺序号' clearable)
              el-tooltip(class="item" effect="dark" content="1-99，用于小程序端图标显示顺序，数字越大越靠前。" placement="right")
                i(class="el-icon-warning-outline icon")
            el-form-item(label='关联主办方' prop='orgId')
              el-select.sel_width_ct(v-model="dataForm.orgId", placeholder="主办方列表" filterable clearable)
                el-option(v-for="(item,index) in orgIds" :key="index" :label="item.name" :value="item.id")
            el-form-item(label='简介' prop='intro')
                el-input.width_ct(type='textarea' v-model='dataForm.intro' maxlength="200" show-word-limit :rows=6 resize="none" placeholder='请填写简介')
            el-form-item(label='是否启用', prop='enable')
                el-checkbox(v-model="dataForm.enable")
      span.dialog-footer(slot='footer')
        el-button(v-if="dataForm.id" type='primary', @click="submit('edit')") 保存修改
        el-button(v-else type='primary', @click="submit('add')") 确定
        el-button(@click='visible = false') 取消
</template>

<script>
import {
  orgList,
  CreatePartner,
  ManagePartner
} from '@/api/pages/news/partner/index.js';
export default {
  data () {
    var validatorSort = (rule, value, callback) => {
      value = value - 0;
      if (!Number.isInteger(value) || !(value >= 1 && value <= 99)) {
        callback(new Error('只能输入1-99的整数！'));
      } else {
        callback();
      }
    };
    return {
      visible: false,
      type_list: [
        {
          label: '战略合作伙伴',
          value: 0
        },
        {
          label: '赞助商',
          value: 1
        },
        {
          label: '供应商',
          value: 2
        }
      ],
      orgIds: [],
      imageUrl: '',
      openImg: '',
      dataForm: {
        id: null,
        title: null,
        type: null,
        logo: null,
        logo_sort: null,
        orgId: null,
        intro: null,
        enable: false
      },
      loading: null,
      dataRule: {
        title: [
          { required: true, message: '合作方名称不能为空！', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '合作方类型不能为空！', trigger: 'change' }
        ],
        logo: [{ required: true, message: '必须上传LOGO！', trigger: 'blur' }],
        logo_sort: [
          { required: true, message: 'LOGO排序号不能为空！', trigger: 'blur' },
          { validator: validatorSort, trigger: 'blur' }
        ],
        enable: [{ required: true, message: '不能为空！', trigger: 'change' }]
      }
    };
  },
  methods: {
    init (row) {
      if (row) {
        // 修改
        let { title, type, logoUrl, logoSort, intro, status, orgId, id } = row;
        this.dataForm = {
          id,
          title,
          type,
          logo: logoUrl,
          logo_sort: logoSort,
          orgId,
          intro,
          enable: status !== 0
        };
        this.imageUrl = logoUrl;
      }
      this.visible = true;
      // 获取关联主办方下拉数据
      let params = {
        page: 1,
        limit: 999
      };
      orgList(params).then(res => {
        if (res.code === 0) {
          this.orgIds = res.page.records;
        }
      });
    },
    //loading效果  this.loading.close()
    openFullScreen () {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    // 上传LOGO
    openImgdailog () {
      this.openImg = true;
      this.$nextTick(() => {
        this.$refs.upimg.init('pbNews'); //传入图片类型参数
      });
    },
    doneup (val, url) {
      console.log( val, url)
      this.dataForm.logo = val;
      this.imageUrl = url;
    },
    submit (which_type) {
      this.$refs.dataForm.validate(val => {
        let {
          id,
          title,
          type,
          logo,
          logo_sort,
          orgId,
          intro,
          enable
        } = this.dataForm;
        if (val) {
          let data = {
            title,
            type,
            logoUrl: logo,
            logoSort: logo_sort,
            orgId,
            intro,
            status: enable ? 1 : 0
          };
          if (which_type === 'add') {
            CreatePartner(data).then(res => {
              if (res.code === 0) {
                this.$message.success(res.data);
                this.visible = false;
                this.$emit('getDataList');
              }
            });
          } else {
            data.id = id;
            let arr_tmp = [];
            arr_tmp.push(data);
            let edit_data = {
              flag: 0,
              partners: arr_tmp
            };
            ManagePartner(edit_data).then(res => {
              if (res.code === 0) {
                this.$message.success(res.data);
                this.visible = false;
                this.$emit('getDataList');
              }
            });
          }
        }
      });
    },
    reset () {
      this.imageUrl = null;
      this.openImg = null;
      this.dataForm = {
        id: null,
        title: null,
        type: null,
        logo: null,
        logo_sort: null,
        orgId: null,
        intro: null,
        enable: false
      };
      this.loading = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.width_ct {
  width: 50%;
}
.sel_width_ct,
.input_width_ct {
  width: 20% !important;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #ccc;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.dialog-footer {
  padding-bottom: 150px;
}
// me
.icon {
  font-size: 24px;
  margin: 0 0 0 10px;
  cursor: pointer;
}
</style>
